<template>
	<div class="m-portlet m-portlet--mobile">
		<div class="m-portlet__head">
			<div class="m-portlet__head-caption">
				<nav aria-label="breadcrumb" class="breadcrumb-container">
					<ol class="breadcrumb">
						<router-link v-if="(breadcrumb.length - 1) != idx" tag="li" :to="{ name: 'AccountList', params: { code: br }}" v-for="(br, idx) in breadcrumb" active-class="active" class="breadcrumb-item">
							<a>
								{{br}}
							</a>
						</router-link>

						<li class="active breadcrumb-item" v-else><span>{{br}}</span></li>
					</ol>
				</nav>
			</div>
			<div class="m-portlet__head-tools">
	            <ul class="m-portlet__nav pull-right" style="list-style-type: none;">
					<router-link tag="li" :to="{ name: 'EditAccount', params: { code: 'admin' }}" class="acc-action m-portlet__nav-item" v-if="this.user.role == 'admin'">
						<a class="btn btn-primary">
							Cấu hình mặc định
						</a>
					</router-link>
					<li class="acc-action m-portlet__nav-item m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push" m-dropdown-toggle="hover" aria-expanded="true">
						<div class="btn-group">
							<button id="create-acc-group" type="button" class="btn btn-primary" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								Tạo tài khoản
							</button>
							<div class="dropdown-menu" x-placement="bottom-start" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 40px, 0px);">
								<h6 class="dropdown-header">Tạo &#38; cấu hình tài khoản</h6>
								<router-link tag="li" :to="{ name: 'CreateAccount', params: { role: act.role_type, currentCode:$route.params.code }}" v-for="act in this.actions" class="m-nav__item">
									<a href="" class="m-nav__link">
										<span class="m-nav__link-text">{{act.alias}}</span>
									</a>
								</router-link>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="m-portlet__body">
			<div class="searching">
				<input v-model="searchQuery" type="text" class="form-control m-input searchInput" placeholder="Tìm nhanh mã hoặc tên đăng nhập">
				<a @click="searchUser" href="javascript:;" class="btn btn-sm btn-primary">Tìm kiếm</a>
			</div>
			<router-view
				:users="this.users"
				:search="this.searchQuery"
				:viewer="this.viewer"
				v-on:reload-table="this.onReload"
			/>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	export default {
		data(){
			return{
				"actions": [],
				"breadcrumb": [],
				"users": [],
				"viewer": this.$route.params.code,
				"searchQuery": ""
			}
		},

		computed: {
			...mapGetters({
		  		user: 'user'
			})
		},

		created() {
	    	this.fetchAction();
			this.tryToLoadRouter(this.user);
		},

		watch:{
			user: function(u){ // run if reload browser
				this.tryToLoadRouter(u);
			}
		},

		beforeRouteUpdate (to, from, next) {
			if(from.name == "EditAccount" || from.name == "CreateAccount"){
				$("#create-acc-group").removeAttr("disabled");
			}

			let code = to.params.code ? to.params.code : this.user.code;
			code = code == "administrator" ? "" : code;

			if(to.name == "AccountListRoot"){
				// this.fetchAccountList(this.user.code, ()=>{ next(); });
				this.tryToLoadRouter(this.user);
			}else{
				this.viewer = code == "admin" ? "" : code;
				this.fetchAccountList(code);
				this.searchQuery = "";
				next();
			}
		},

		methods: {
			tryToLoadRouter: function(u){
				let router = {name: 'AccountList', params: { code: "admin" } };
				router["params"] = (u.role == "admin" || (u.code == "" && u.role == "clone")) ? { code: "admin" } : { code: u.code };

				this.$router.replace(router);
			},
			fetchAccountList: async function(code = null, callback = null){
				code = code != null ? code : this.$route.params.code;
				code = code ? code : "";

				let url = 'admin-panel/user/list_child?code=' + code;
				let res = await axios.get(url);
				res = res.data;

				this.breadcrumb = res.data.breadcrumb;
				this.users = res.data.users;
				this.viewer = this.$route.params.code;

				if(callback) callback();
			},
			onReload: function(code=null){
				if(!code){
					this.fetchSubAccountList(code);
					return;
				}
				this.fetchAccountList(code);
			},
			fetchAction: async function(){
				let res = await window.axios.get("/admin-panel/user/list_action");
	            res = res.data;

	            if(res.code == 0){
	            	this.actions = res.data.filter(r => { return r.role_type != "admin"; })
	            }
			},
			onCreateAccountToggle: function(e){
				// $(e.currentTarget).parent().find(".m-dropdown__wrapper").show();
				$(e.currentTarget).dropdown("toggle");;
			},
			searchUser: async function(){
				if(this.searchQuery == "") return;
				
				let url = 'admin-panel/user/search_child/' + this.searchQuery;
				let res = await axios.get(url);
				res = res.data;

				this.breadcrumb = res.data.breadcrumb;
				this.users = res.data.users;
				this.viewer = this.$route.params.code;
			}
		}
	}
</script>

<style>
	.searchInput{
		width: 250px;
		display: inline-block;
		margin-right: 5px;
	}
</style>